import React from 'react'
import './brand.css'
import {
  google,
  slack,
  atlassian,
  dropbox,
  shopify
} from './imports'
import { motion, useScroll, useTransform } from 'framer-motion'

const Brand = () => {
  const { scrollYProgress } = useScroll();
  let left = useTransform(scrollYProgress, [0, .3, 1], [0, -200, -300]);
  let right = useTransform(scrollYProgress, [0, .3, 1], [0, 300, 300]);
  return (
    <div className='gpt3__brand section__padding'>
      <motion.div style={{ x: left }}>
        <img src={google} alt="google" />
      </motion.div>
      <motion.div style={{ x: right }}>
        <img src={slack} alt="slack" />
      </motion.div>
      <motion.div style={{ x: left }}>
        <img src={atlassian} alt="atlassian" />
      </motion.div>
      <motion.div style={{ x: right }}>
        <img src={dropbox} alt="dropbox" />
      </motion.div>
      <motion.div style={{ x: left }}>
        <img src={shopify} alt="shopify" />
      </motion.div>
    </div>
  )
}

export default Brand